import * as THREE from "three";
import vDefaultShader from '../shaders/default_vert.glsl'
import fMarkerShader from '../shaders/marker_frag.glsl'

import { gsap, Power4 } from "gsap";

export class WorldMarker {
    constructor(name, assets, textureName){
        this.assets = assets
        this.map = this.assets.textures[textureName]
        this.name = name
        this.material = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: this.map },
                noiseMap: { value: this.assets.textures.noise },
                hatchingScale: { value: 1 },
                hatchingMap: { value: this.assets.textures.hatchC },
                mixDiffuse: { value: 0 },
                whiteLevel: { value: 1 },
                blackLevel: { value: 0 },
                time: { value: 0 },
                intensity: {value: .15},
            },
            vertexShader: vDefaultShader,
            fragmentShader: fMarkerShader,
            transparent: true,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
            depthTest: false,
        })
        const geom = new THREE.PlaneGeometry(.03,.03);
        this.model = new THREE.Mesh(geom, this.material);
        this.model.refButton = this;
        this.model.visible = true;
        this.activated = false;
    }

    loop(params){
        this.material.uniforms.time.value = params.time;
    }

    deactivate(){
        this.activated = false
        gsap.to(this.material.uniforms.intensity, {
            value : .15,
            duration : 1,
            ease : Power4.easeOut,
        })
    }

    activate(){
        this.model.visible = true
        this.activated = true

        gsap.to(this.material.uniforms.intensity, {
            value : .5,
            duration : 1,
            delay : 2,
            ease : Power4.easeOut,
        })
    }

    mouseOver() {
        if (this.activated) return;

        gsap.to(this.material.uniforms.intensity, {
            value : .5,
            duration : 1,
            ease : Power4.easeOut,
        })
    }

    mouseOut() {
        if (this.activated) return;

        gsap.to(this.material.uniforms.intensity, {
            value : .15,
            duration : 1,
            ease : Power4.easeOut,
        })
    }
}